<template>
  <div class="FormInscripcion">
    <div v-if="FormInscripcion">
      <form-wizard @on-complete="onComplete" next-button-text="Siguiente" back-button-text="Regresar" finish-button-text="Guardar" title subtitle color="#222">
        <tab-content :title="this.labelFields.fields1" icon="ti-user" :before-change="beforeTabSwitch1">
          <div class="container">
            <div class="row">
              <div class="col-md-12 infoForm">
                <FormDataInscription /> 
              </div> 
              <div class="col-md-12 totalform">  
                <div v-if="infoData" class="alert alert-danger">
                  <p>
                    Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
                  </p>
                </div>
                <div v-if="alertUpdate" class="alert alert-danger">
                  <p>
                    Los datos no han sido actualizados correctamente, por favor validar nuevamente. En caso que el caso persista, por favor te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
                  </p>
                </div>
                <ValidationObserver ref="obsFields1">
                  <FormInscription :FieldsForm="formInscription.fields1" :ModelForm="formInsModel" :method="executeProcess" />                                     
                </ValidationObserver>
              </div>       
            </div>
          </div>
        </tab-content>
      </form-wizard>  
    </div>
    
  </div>
</template>

<script>
import FormDataInscription from '@/views/InfoZone/FormGraduated.vue'
import FormInscription from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {  
  name: "FormInscripcion",
  components: {
    FormDataInscription,
    FormInscription,
  },
  methods: {
    dataObjCheck: function(InfDaT){
      if(InfDaT === true){
        return this.$ml.get('Accepted');   
      }
      return this.$ml.get('NotAccepted');    
    },
    valNacionality: function(InfDat){
      if(document.getElementById("sum_IdStateBirth") != null){
        if (InfDat.IdNacionality != 169) {
          document.getElementById("sum_IdStateBirth").classList.add('noShow');
          document.getElementById("sum_IdCityBirth").classList.add('noShow');
        } else {
          document.getElementById("sum_IdStateBirth").classList.remove('noShow');
          document.getElementById("sum_IdCityBirth").classList.remove('noShow');
        }
      }
    },
    loadFindData: function(restJson) {
      this.formInsModel.IdNombres = restJson.Nombres
      this.formInsModel.IdApellidos = restJson.Apellidos
      this.formInsModel.IdDireccion = restJson.Direccion
      this.formInsModel.IdHomePhone = restJson.Telefono
      this.formInsModel.IdCelPhone = restJson.Celular
      this.formInsModel.IdCorreo = restJson.Correo
      this.formInsModel.IdState = restJson.Departamento
      this.formInsModel.IdCity = restJson.Ciudad
      IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,restJson.Departamento);
      this.formInscription.fields1[11].values = this.$store.state.CityList
      this.formInsModel.IdState = restJson.Departamento
      this.formInsModel.IdCity = restJson.Ciudad
      this.formInsModel.IdPerson = restJson.IdPerson
      this.formInsModel.IdBanner = restJson.IdBanner

      document.getElementById("IdNombres").readOnly = false;
      return true
    },
    dataformat: function(InfDaT){
      return IberoHelpers.dataObjDate(InfDaT);
    },
    dataObjFindJs: function(infoDaT,FinDaT){        
      return IberoHelpers.dataObjFind(infoDaT,FinDaT);
    },
    dataObjAllFind: function(infoDaT,FinDaT){        
      return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
    },    
    executeProcess: function (event) {    
      switch (event.target.id) {
        case "IdDocType":
          this.formInsModel.IdDocument = '';
        break; 
        case "IdDocument":
            if(event.type === 'blur' && 
            this.formInsModel.IdDaySelect !== '' && this.formInsModel.IdMonthSelect !== '' && 
            this.formInsModel.IdYearSelect !== '' && this.formInsModel.IdDocument !== '') {  
              var pruebaUser = IberoHelpers.findGraduatedData(this.$store, this.formInsModel);
              pruebaUser.then(Response => {
                if (!(Response === false)){
                  if (Response.data.length > 0) {            
                    this.infoData = false;
                    this.loadFindData(Response.data[0])
                  }
                  else
                  {
                    this.infoData = true;
                  }
                }
                else{
                  this.infoData = true;
                }
              })
            }
        break;
        case "IdState":
          this.formInsModel.IdCity = '';
          if(event.target.value === ''){            
            this.formInscription.fields1[10].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,event.target.value);
            this.formInscription.fields1[11].values = this.$store.state.CityList;
          }
        break;
        case "cbox_IdTermiCondi":                   
          event.target.disabled = true;   
        break; 
        return true;
      }        
    },    
    onComplete: function() {
      this.alertdanger = false;
      return new Promise((resolve, reject) => {
        this.$refs.obsFields1.validate().then(results => {
          if (!results) {
              IberoHelpers.scrollToTop(0,300);
              resolve(false)
            }else{
              let loader = this.$loading.show()
              var totalinf = IberoHelpers.sendFormUpdateGraduated(
                this.$store,
                this.formInsModel,
              )
              totalinf.then(Response => {
                if (!(Response === false)) {
                    if (Response.data.status === '200') {                                
                      loader.hide();
                      IberoHelpers.scrollToTop(0,500);
                      resolve(true)
                      alert('Tus datos fueron actualizados correctamente.');
                      var pruebaUser = IberoHelpers.findGraduatedData(this.$store, this.formInsModel);
                      pruebaUser.then(Response => {
                        if (Response.data.length > 0) {            
                          this.infoData = false;
                          this.loadFindData(Response.data[0])
                        }
                        else
                        {
                          this.infoData = true;
                        }
                      });
                    } else {
                      loader.hide();
                      this.alertUpdate = true;
                      resolve(false)
                    }
                } else {
                  loader.hide();
                  this.alertUpdate = true;
                  resolve(false)
                }
              });

            }
        });
      });
    },
    beforeTabSwitch1: function() {               
      return new Promise((resolve, reject) => {
          this.$refs.obsFields1.validate().then(results => {         
            if (!results) {
              IberoHelpers.scrollToTop(0,500);
              resolve(false)
            }else{
              IberoHelpers.sendFormPQRSTemp(this.$store,this.formInsModel);
              resolve(true)
            }
          });
      });
    }
  },
  data() {
    return {
      FormInscripcion: true,
      alertdanger: false,
      alertUpdate: false,
      infoData: false,
      sumaryData: [],
      sendCase: [],
      labelFields:{
        fields1:'Perfil de Egresado',
      },
      formInsModel: {
        Campaign: this.$route.params.referencia,
        IdDocument: '',
        IdDaySelect: '',
        IdMonthSelect: '',
        IdYearSelect: '',
        IdNombres : '',
        IdApellidos: '',
        IdCorreo: '',
        IdDireccion: '',
        IdCelPhone: '',
        IdHomePhone: '',
        IdState: '',
        IdCity: '',
        IdTermiCondi: '',
        IdPerson: '',
        IdBanner: '',
      }, 
      formInscription:{       
        fields1:[
          {            
            id: 'IdDaySelect',
            model: 'IdDaySelect',
            name: 'Fecha de Nacimiento',
            type: 'Select',  
            placeholder: "Día",
            values: [
                { id: "1", value: "1" },
                { id: "2", value: "2" },
                { id: "3", value: "3" },
                { id: "4", value: "4" },
                { id: "5", value: "5" },
                { id: "6", value: "6" },
                { id: "7", value: "7" },
                { id: "8", value: "8" },
                { id: "9", value: "9" },
                { id: "10", value: "10" },
                { id: "11", value: "11" },
                { id: "12", value: "12" },
                { id: "13", value: "13" },
                { id: "14", value: "14" },
                { id: "15", value: "15" },
                { id: "16", value: "16" },
                { id: "17", value: "17" },
                { id: "18", value: "18" },
                { id: "19", value: "19" },
                { id: "20", value: "20" },
                { id: "21", value: "21" },
                { id: "22", value: "22" },
                { id: "23", value: "23" },
                { id: "24", value: "24" },
                { id: "25", value: "25" },
                { id: "26", value: "26" },
                { id: "27", value: "27" },
                { id: "28", value: "28" },
                { id: "29", value: "29" },
                { id: "30", value: "30" },
                { id: "31", value: "31" }
            ],
            validate: {              
              required: true              
            },
            class: 'col-md-2',
          },
          {
            id: 'IdMonthSelect',
            model: 'IdMonthSelect',
            name: '',
            type: 'Select',  
            placeholder: 'Mes',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values: [
                { id: "01", value: "Enero" },
                { id: "02", value: "Febrero" },
                { id: "03", value: "Marzo" },
                { id: "04", value: "Abril" },
                { id: "05", value: "Mayo" },
                { id: "06", value: "Junio" },
                { id: "07", value: "Julio" },
                { id: "08", value: "Agosto" },
                { id: "09", value: "Septiembre" },
                { id: "10", value: "Octubre" },
                { id: "11", value: "Noviembre" },
                { id: "12", value: "Diciembre" }
            ]
          },
          {
            id: 'IdYearSelect',
            model: 'IdYearSelect',
            name: '',
            type: 'Select',  
            placeholder: 'Año',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values:[
                { id: "2026", value: "2026" },
                { id: "2025", value: "2025" },
                { id: "2024", value: "2024" },
                { id: "2023", value: "2023" },
                { id: "2022", value: "2022" },
                { id: "2021", value: "2021" },
                { id: "2020", value: "2020" },
                { id: "2019", value: "2019" },
                { id: "2018", value: "2018" },
                { id: "2017", value: "2017" },
                { id: "2016", value: "2016" },
                { id: "2015", value: "2015" },
                { id: "2014", value: "2014" },
                { id: "2013", value: "2013" },
                { id: "2012", value: "2012" },
                { id: "2011", value: "2011" },
                { id: "2010", value: "2010" },
                { id: "2009", value: "2009" },
                { id: "2008", value: "2008" },
                { id: "2007", value: "2007" },
                { id: "2006", value: "2006" },
                { id: "2005", value: "2005" },
                { id: "2004", value: "2004" },
                { id: "2003", value: "2003" },
                { id: "2002", value: "2002" },
                { id: "2001", value: "2001" },
                { id: "2000", value: "2000" },
                { id: "1999", value: "1999" },
                { id: "1998", value: "1998" },
                { id: "1997", value: "1997" },
                { id: "1996", value: "1996" },
                { id: "1995", value: "1995" },
                { id: "1994", value: "1994" },
                { id: "1993", value: "1993" },
                { id: "1992", value: "1992" },
                { id: "1991", value: "1991" },
                { id: "1990", value: "1990" },
                { id: "1989", value: "1989" },
                { id: "1988", value: "1988" },
                { id: "1987", value: "1987" },
                { id: "1986", value: "1986" },
                { id: "1985", value: "1985" },
                { id: "1984", value: "1984" },
                { id: "1983", value: "1983" },
                { id: "1982", value: "1982" },
                { id: "1981", value: "1981" },
                { id: "1980", value: "1980" },
                { id: "1979", value: "1979" },
                { id: "1978", value: "1978" },
                { id: "1977", value: "1977" },
                { id: "1976", value: "1976" },
                { id: "1975", value: "1975" },
                { id: "1974", value: "1974" },
                { id: "1973", value: "1973" },
                { id: "1972", value: "1972" },
                { id: "1971", value: "1971" },
                { id: "1970", value: "1970" },
                { id: "1969", value: "1969" },
                { id: "1968", value: "1968" },
                { id: "1967", value: "1967" },
                { id: "1966", value: "1966" },
                { id: "1965", value: "1965" },
                { id: "1964", value: "1964" },
                { id: "1963", value: "1963" },
                { id: "1962", value: "1962" },
                { id: "1961", value: "1961" },
                { id: "1960", value: "1960" },
                { id: "1959", value: "1959" },
                { id: "1958", value: "1958" },
                { id: "1957", value: "1957" },
                { id: "1956", value: "1956" },
                { id: "1955", value: "1955" },
                { id: "1954", value: "1954" },
                { id: "1953", value: "1953" },
                { id: "1952", value: "1952" },
                { id: "1951", value: "1951" },
                { id: "1950", value: "1950" },
                { id: "1949", value: "1949" },
                { id: "1948", value: "1948" },
                { id: "1947", value: "1947" },
                { id: "1946", value: "1946" },
                { id: "1945", value: "1945" },
                { id: "1944", value: "1944" },
                { id: "1943", value: "1943" },
                { id: "1942", value: "1942" },
                { id: "1941", value: "1941" },
                { id: "1940", value: "1940" },
            ],
          },
          {            
            id: 'IdDocument',
            model: 'IdDocument',
            name: 'Documento de Identidad',
            type: 'input',  
            placeholder: 'Documento de Identidad',
            values: '',
            validate: {              
              required: true, 
              min: 5,              
              max: 12            
            },
            class: 'col-md-6',        
          },
          {            
            id: 'IdNombres',
            model: 'IdNombres',
            name: 'Nombres',
            type: 'input',  
            placeholder: 'Nombres',
            values: '',
            validate: {              
              required: true, 
            },
            class: 'col-md-6',
          },
          {            
            id: 'IdApellidos',
            model: 'IdApellidos',
            name: 'Apellidos',
            type: 'input',  
            placeholder: 'Apellidos',
            values: '',
            validate: {              
              required: true, 
            },
            class: 'col-md-6',
          },
          {            
            id: 'IdDireccion',
            model: 'IdDireccion',
            name: 'Dirección',
            type: 'input',  
            placeholder: 'Dirección',
            values: '',
            validate: {              
              required: true, 
            },
            class: 'col-md-6',
          },
          {            
            id: 'IdCorreo',
            model: 'IdCorreo',
            name: 'Correo Electrónico',
            type: 'input',  
            placeholder: 'Correo Electrónico',
            values: '',
            validate: {              
              required: true, 
            },
            class: 'col-md-6',
          },
          {            
            id: 'IdHomePhone',
            model: 'IdHomePhone',
            name: 'Teléfono Fijo',
            type: 'input',  
            placeholder: 'Teléfono Fijo',
            values: '',
            validate: {
              required: false, 
              numeric: true,
              max: 7
            },
            class: 'col-md-6'               
          },           
          {            
            id: 'IdCelPhone',
            model: 'IdCelPhone',
            name: 'Teléfono Celular',
            type: 'input',  
            placeholder: 'Teléfono Celular',
            values: '',
            validate: {
              required: true, 
              numeric: true,
              max: 10,
              min: 10 
            },  
            class: 'col-md-6'               
          },
          {
            id: 'IdState',
            model: 'IdState',
            name: 'Departamento de Residencia',
            type: 'Select',  
            placeholder: 'Departamento de Residencia',
            validate: {              
              required: true              
            },
            class: 'col-md-6',            
            values: this.$store.state.StateList,
          },
          {
            id: 'IdCity',
            model: 'IdCity',
            name: 'Ciudad de Residencia',
            type: 'Select',  
            placeholder: 'Ciudad de Residencia',
            validate: {              
              required: true              
            },
            class: 'col-md-6',            
            values: this.$store.state.CityList,
          },
          {            
            id: 'IdTermiCondi',
            name: 'Términos y Condiciones',
            model: 'IdTermiCondi',
            type: 'accepted',  
            disabled: false,
            placeholder: 'Acepto los <a class="linkTerm" href="' + this.$store.state.linkTermiCondi + '" target="_blank">Términos y Condiciones</a> de uso.',
            values: '',
            validate: {              
              required: true,
            },
            class: 'col-md-6 linkref'                
          },           
          {            
            id: 'IdPerson',
            model: 'IdPerson',
            name: '',
            type: 'input',  
            disabled: false,
            placeholder: 'Persona',
            values: '',
            class: 'col-md-3'               
          },
          {            
            id: 'IdBanner',
            model: 'IdBanner',
            name: '',
            type: 'input',  
            disabled: false,
            placeholder: 'Banner',
            values: '',
            class: 'col-md-3'               
          }
        ]
      }
    }
  }
}
</script>

<style scope>


.FormInscripcionOK .wizard-card-footer{
  display: none;
} 

.totalform {
  padding-top: 10px;
  padding-bottom: 30px;
  background-color: #ffffff;
}

.wizard-progress-with-circle {
  display: none !important;
}

.wizard-nav-pills, .wizard-card-footer{
  margin-left: 5% !important;   
  margin-right: 5% !important;
} 

.vue-form-generator, fieldset{
  display: contents;
}

.linkref{
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: -5px;
}

#div_IdICFESText{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -20px;
}

#div_IdAddressNumTxt, #div_IdAddressRefTxt{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
  text-align: center;
}

#IdMonthSelect{
  top: 17px;
}

#error_IdMonthSelect{
  margin-top: 10px;
}

#IdYearSelect{
  top: 17px;
}

#error_IdYearSelect{
  margin-top: 10px;
}

.linkref a{
  color: #222 !important;
}

.noShow{
  display: none;
}

#div_IdTermiCondi .titleRef, #div_IdHomolo .titleRef, #div_IdComproMatricula .titleRef{
  color: #ffffff;
  margin-top: 10px;
}

.titleRefSumary{
  font-weight: bold;
  text-transform: uppercase;
  text-decoration-line: underline;
  margin-top: 20px;
  margin-bottom: 20px;
}

.titleSumary{
    font-weight: bold;
}

.active
{
  color: #222;
}

.listSumary{
  font-size: 13px;
}
.botonRef {
  margin-top: 5px;
  max-width: 200px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.botonPay {
  margin-top: 5px;
  max-width: 250px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.detalleAddress .is-invalid-form{
  display: none;
}

#sum_IdOperator, #sum_IdICFESText{
  display: none;
}

.botonData{
  margin-right: 10px;
  margin-bottom: 30px;
  margin-top: 20px;
}

body {
    background:  #fff ;   
}
header {
    background:  #ffffff !important;   
}
</style>
